var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-button",class:{ 'toggle-button--active': _vm.active, 'toggle-button--disabled': _vm.disabled, 'toggle-button--iframe': _vm.esCamaraIframe },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }